// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__141j3","bigColWidth":"Table_bigColWidth__29K3W","biggerColWidth":"Table_biggerColWidth__1zdE2","row":"Table_row__3py2K","col":"Table_col__37MVv"};